const DataChannel = 
[{
    "name": "hookload",
    "status": "enable",
    "slideBy": 120000,
    "windowLength": 3600000,
    "indexes": [
        "aswi",
        "dqi"
    ],
    "aspects": [
        {
            "name": "frequency",
            "status": "enable",
            "expectedValue": 1,
            "deltaValue": 10,
            "weightage": 30,
            "ttThreshold": 20000
        },
        {
            "name": "precision",
            "status": "enable",
            "expectedValue": 2,
            "weightage": 10,
            "ttThreshold": 100000
        },
        {
            "name": "dataGap",
            "status": "enable",
            "expectedValue": 10000,
            "weightage": 30
        },
        {
            "name": "dataCount",
            "status": "enable",
            "expectedValue": 36000,
            "deltaValue": 60,
            "ttThreshold": 30000,
            "weightage": 30
        },
        {
            "name": "latency",
            "status": "enable",
            "expectedValue": 3000,
            "deltaValue": 60,
            "ttThreshold": 30000,
            "weightage": 10
        },
        {
            "name": "minValue",
            "status": "enable",
            "expectedValue": 10,
            "deltaValue": 2,
            "ttThreshold": 30000,
            "weightage": 10
        },
        {
            "name": "staleValue",
            "status": "enable",
            "ttThreshold": 30000,
            "weightage": 10
        },
        {
            "name": "maxValue",
            "status": "enable",
            "expectedValue": 30000,
            "weightage": 10,
            "ttThreshold": 30000,
            "complexRules": [
                {
                    "mnemonics": "Bit_Depth,Hole_depth",
                    "validateCondition": "($Hole_depth - $Bit_Depth) > 30",
                    "onSuccess": "#2",
                    "onFailure": "#3",
                    "id": "1"
                },
                {
                    "mnemonics": "RPM",
                    "validateCondition": "$RPM=1",
                    "onSuccess": "#3",
                    "onFailure": "=exit",
                    "id": "2"
                },
                {
                    "mnemonics": "FlowIn",
                    "validateCondition": "$FlowIn > 34",
                    "onSuccess": "continue",
                    "onFailure": "exit",
                    "id": "3"
                }
            ]
        }
    ]
},
{
    "name": "hookload111",
    "status": "enable",
    "slideBy": 120000,
    "windowLength": 3600000,
    "indexes": [
        "aswi",
        "dqi"
    ],
    "aspects": [
        {
            "name": "frequency",
            "status": "enable",
            "expectedValue": 1,
            "deltaValue": 10,
            "weightage": 30,
            "ttThreshold": 20000
        },
        {
            "name": "precision",
            "status": "enable",
            "expectedValue": 2,
            "weightage": 10,
            "ttThreshold": 100000
        },
        {
            "name": "dataGap",
            "status": "enable",
            "expectedValue": 10000,
            "weightage": 30
        },
        {
            "name": "dataCount",
            "status": "enable",
            "expectedValue": 36000,
            "deltaValue": 60,
            "ttThreshold": 30000,
            "weightage": 30
        },
        {
            "name": "latency",
            "status": "enable",
            "expectedValue": 3000,
            "deltaValue": 60,
            "ttThreshold": 30000,
            "weightage": 10
        },
        {
            "name": "minValue",
            "status": "enable",
            "expectedValue": 10,
            "deltaValue": 2,
            "ttThreshold": 30000,
            "weightage": 10
        },
        {
            "name": "staleValue",
            "status": "enable",
            "ttThreshold": 30000,
            "weightage": 10
        },
        {
            "name": "maxValue",
            "status": "enable",
            "expectedValue": 30000,
            "weightage": 10,
            "ttThreshold": 30000,
            "complexRules": [
                {
                    "mnemonics": "Bit_Depth,Hole_depth",
                    "validateCondition": "($Hole_depth - $Bit_Depth) > 30",
                    "onSuccess": "#2",
                    "onFailure": "#3",
                    "id": "1"
                },
                {
                    "mnemonics": "RPM",
                    "validateCondition": "$RPM=1",
                    "onSuccess": "#3",
                    "onFailure": "=exit",
                    "id": "2"
                },
                {
                    "mnemonics": "FlowIn",
                    "validateCondition": "$FlowIn > 34",
                    "onSuccess": "continue",
                    "onFailure": "exit",
                    "id": "3"
                }
            ]
        }
    ]
}]

export default DataChannel;